import { render, staticRenderFns } from "./historyForecastbyRoomLevelReport.vue?vue&type=template&id=2d6ad83e"
import script from "./historyForecastbyRoomLevelReport.vue?vue&type=script&lang=js"
export * from "./historyForecastbyRoomLevelReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports